<template>
  <el-dropdown @command="actionsHandler($event, params)" trigger="click">
    <el-button icon="el-icon-more" size="mini" type="plain"></el-button>
    <el-dropdown-menu slot="dropdown">
      <span v-for="(item, key) in items" :key="key">
        <el-dropdown-item  :command="item.action" v-if="isOptionValid(item)" :class="{'border-bottom mb-2': item.borderBottom}">
          <i :class="item.icon"></i> {{ item.label }}
        </el-dropdown-item>
      </span>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  methods: {
    isOptionValid(o) {
      
      if (o.hasOwnProperty('notForProfiles') && o.notForProfiles.includes(this.userProfileId)) return false
      if (o.hasOwnProperty('forProfiles') && !o.forProfiles.includes(this.userProfileId)) return false
      // if(o.action == 'openCustomersList' && this.currentUser != 1) return false  
      // if(o.action == 'openResellerList' && this.currentUser != 1) return false  
      return true
    }
  },
  props: {
    userProfileId: {
      required: true
    },
    actionsHandler: {
      required: true
    },
    items: {
      required: true
    },
    params: {
      required: false,
      default: {}
    },
    currentUser :{
      required : false,
      default : null
    }
  }
}
</script>
